import React from 'react'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'

import { Button, useAppStyles } from '@elgatoylacaja/components'

import { RouteComponentProps, withRouter } from 'react-router-dom'
import { AppContext } from '../contexts/AppContext'

const Intro = (props: RouteComponentProps) => {
  const appStyles = useAppStyles()

  const { dispatch } = React.useContext(AppContext)
  const next = () => {
    dispatch({ type: 'REGISTER_VISIT', route: '/intro' })
  }

  return (
    <>
      <Typography variant="h1" className={appStyles.titleDisplay}>
        Instrucciones
      </Typography>

      <Typography className={appStyles.text} style={{ marginTop: '25px' }}>
        Te vamos a mostrar un listado de características que usualmente se
        utilizan para describir a las personas.
      </Typography>

      <Typography className={appStyles.text} style={{ marginTop: '25px' }}>
        Indicanos por favor en qué medida la frase te describe adecuadamente.
      </Typography>

      <Grid container className={appStyles.mobileAlignBottom}>
        <Button
          color="primary"
          label="Siguiente"
          aria-label="Siguiente"
          onClick={next}
        />
      </Grid>
    </>
  )
}

export default withRouter(Intro)
